'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SkypeControl = function () {
  function SkypeControl(element, args) {
    var _this = this;

    _classCallCheck(this, SkypeControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.value = args.value ? args.value : '';
    this.input.id = window.PRIM.getUUID();
    this.input.type = 'text';
    this.input.autocapitalize = 'off';
    this.input.autocorrect = 'off';
    this.input.spellcheck = 'false';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;

    var onclick = function onclick() {
      if (_this.input.value) {
        var parsedUsername = _this.input.value.trim();
        if (parsedUsername) {
          location.href = 'skype:' + parsedUsername + '?call';
        }
      }
    };

    this.button = document.createElement('button');
    this.button.className = 'icon';
    this.button.onclick = onclick;
    this.button.innerHTML = '\uE0F5';
    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);
    div.appendChild(this.button);

    element.appendChild(fragment);
  }

  _createClass(SkypeControl, [{
    key: 'click',
    value: function click() {
      this.button.click();
    }
  }, {
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.value ? this.input.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.value = value ? value : '';
    }
  }]);

  return SkypeControl;
}();

exports.default = SkypeControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/SkypeControl.js
// module id = 47
// module chunks = 0